import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];
const ABOUT_IMG =
  "https://images.pexels.com/photos/5879915/pexels-photo-5879915.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const CHAPTERS = [
  {
    n: "01",
    title: "Designed around you",
    body: "No two women are the same — so no two 841 plans are either. Everything adapts to your goals, your body and your life, rather than handing every woman the same generic wellness plan.",
  },
  {
    n: "02",
    title: "Everything in one place",
    body: "Workouts, nutrition, recovery, mindfulness and self-reflection — brought together into one calm, personalised experience instead of scattered across your day.",
  },
  {
    n: "03",
    title: "For every part of you",
    body: "Strength for your body, balance for your mind, and a deeper, kinder relationship with yourself.",
  },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="scroll-mt-24 py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-4 sm:px-8 lg:grid-cols-12 lg:gap-20 lg:px-12">
      <div className="lg:col-span-5">
        <motion.div
          initial={{ clipPath: "inset(12% 12% 12% 12% round 2.5rem)", opacity: 0.5 }}
          whileInView={{ clipPath: "inset(0% 0% 0% 0% round 2.5rem)", opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.3, ease: EASE }}
          className="overflow-hidden rounded-[2.5rem]"
        >
          <motion.img
            src={ABOUT_IMG}
            alt="A woman resting peacefully in water, eyes closed"
            data-testid="about-image"
            initial={{ scale: 1.12 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.6, ease: EASE }}
            className="aspect-[3/4] w-full object-cover"
          />
        </motion.div>
      </div>

      <div className="lg:col-span-7">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: EASE }}
          className="text-xs font-semibold uppercase tracking-[0.25em] text-gold-dark"
        >
          About 841
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
          className="mt-5 font-serif text-2xl leading-snug tracking-tight text-ink sm:text-3xl lg:text-4xl"
        >
          Wellness, made personal.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.2, ease: EASE }}
          className="mt-6 max-w-xl text-sm leading-relaxed text-[#4A433F] sm:text-base"
        >
          841 brings workouts, nutrition, recovery, mindfulness and self-reflection together into
          one personalised experience for women — designed to help you become stronger, more
          balanced, and more connected to yourself.
        </motion.p>

        <div className="mt-12">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid={`about-chapter-${c.n}`}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.85, delay: i * 0.12, ease: EASE }}
              className="group grid grid-cols-[3.5rem_1fr] gap-4 border-t border-[rgba(26,24,23,0.09)] py-7 transition-colors duration-500 last:border-b hover:bg-white/50 sm:grid-cols-[5rem_1fr] sm:gap-8 sm:px-4"
            >
              <span className="font-serif text-3xl italic text-gold/50 transition-colors duration-500 group-hover:text-gold sm:text-4xl">
                {c.n}
              </span>
              <div>
                <h3 className="font-serif text-xl font-medium text-ink-soft sm:text-2xl">
                  {c.title}
                </h3>
                <p className="mt-2 max-w-lg text-sm leading-relaxed text-[#5C5450]">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
